import { downloadNLForms } from './downloadNLForms';
import { fetchNLForms } from './fetchNLForms';
import { getNLForm } from './getNLForm';
import { getOperatorReportFormStacks } from './getOperatorReportFormStacks';
import { postGourmetNLForm } from './postGourmetNLForm';
import { postHomeServicesForm } from './postHomeServicesForm';
import { postNLForm } from './postNLForm';
import { postOperatorReportNLForm } from './postOperatorReportNLForm';
import { updateNLForm } from './updateNLForm';

export const needLoveService = {
  downloadNLForms,
  fetchNLForms,
  getNLForm,
  getOperatorReportFormStacks,
  postGourmetNLForm,
  postHomeServicesForm,
  postNLForm,
  postOperatorReportNLForm,
  updateNLForm,
};
